export default __webpack_public_path__ + "static/12-ef1dde310e66cb718f7916f8a62eab9e.jpg";